import React from 'react';
import { Stack, StackChild } from '@tanium/react-stack';
import { FormTitle } from './FormTitle';
import { RequiredKey } from './RequiredKey';

export interface FormHeaderProps {
  /**
   * Whether to show a key indicating that a red star means "required". Enabled by default; should
   * always be enabled if the form contains any required inputs.
   */
  showRequiredKey?: boolean;
  /**
   * The title to display.
   */
  title?: React.ReactNode;
}

export const FormHeader = ({ showRequiredKey = true, title }: FormHeaderProps) => (
  <Stack itemSpacing={2}>
    <StackChild grow={1}>{title && <FormTitle>{title}</FormTitle>}</StackChild>
    {showRequiredKey && (
      <StackChild shrink={0} alignSelf="flex-end">
        <RequiredKey />
      </StackChild>
    )}
  </Stack>
);
